import styled, {css, keyframes} from "styled-components"

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const Loader = styled.div`
  ${({theme}) => css`
    border: ${theme.spacing.half} solid ${theme.colors.secondary2_50};
    border-radius: 50%;
    border-top: ${theme.spacing.half} solid ${theme.colors.tertiary.g_400};
    width: 20px;
    height: 20px;
    -webkit-animation: ${spin} 2s linear infinite; /* Safari */
    animation: ${spin} 2s linear infinite;
  `}
`
